export const STORAGE_KEYS = {
	CHECKOUT_UID: 'checkout-uid',
};
